const PreviewSize = {
  maxWidth: 708,
  maxHeight: 615
};

export default PreviewSize;



// WEBPACK FOOTER //
// ./src/constants/preview-size.js